module.exports = __webpack_public_path__ + "static/media/historical-bk.0edd8a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/home/historical-bk.jpg
// module id = 298
// module chunks = 0